// @systeme: interface
// L'onglet Listes : les courses d'abord, puis les listes libres (valise, rentrée…).
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ListChecks, ShoppingBasket } from 'lucide-react';
import { Link as LienRouteur, useNavigate } from 'react-router';
import type { ResumeListe } from '@foyer/shared';
import { Chargement } from '../composants/Chargement';
import { useMessages } from '../composants/Messages';
import { api } from '../lib/api';
import { couleurs, tailles } from '../theme/theme';

export function Listes() {
  const navigate = useNavigate();
  const { direErreur } = useMessages();
  const [listes, setListes] = useState<ResumeListe[] | undefined>();
  const [nouvelle, setNouvelle] = useState(false);
  const [nom, setNom] = useState('');
  const [enCours, setEnCours] = useState(false);

  useEffect(() => {
    api.listes.lister().then(setListes).catch(direErreur);
  }, [direErreur]);

  async function creer() {
    if (nom.trim() === '') return;
    setEnCours(true);
    try {
      const liste = await api.listes.creer(nom.trim());
      void navigate(`/listes/${liste.id}`);
    } catch (e) {
      direErreur(e);
    } finally {
      setEnCours(false);
    }
  }

  if (!listes) return <Chargement />;

  return (
    <Box sx={{ px: `${tailles.marge}px`, pt: 3 }}>
      <Typography variant="h1" component="h1" sx={{ mb: 2 }}>
        Listes
      </Typography>
      <List disablePadding>
        {listes.map((l) => (
          <ListItemButton
            key={l.id}
            component={LienRouteur}
            to={`/listes/${l.id}`}
            sx={{
              bgcolor: couleurs.blanc,
              borderRadius: `${tailles.rayon}px`,
              mb: 1,
              border: 1,
              borderColor: 'divider',
              minHeight: tailles.cible + 12,
            }}
          >
            <ListItemIcon sx={{ minWidth: 40, color: couleurs.sauge }}>
              {l.type === 'courses' ? <ShoppingBasket size={24} /> : <ListChecks size={24} />}
            </ListItemIcon>
            <ListItemText
              primary={l.nom}
              secondary={
                l.nombreAFaire === 0
                  ? 'rien à prendre'
                  : l.nombreAFaire === 1
                    ? '1 chose à prendre'
                    : `${l.nombreAFaire} choses à prendre`
              }
            />
          </ListItemButton>
        ))}
      </List>

      {nouvelle ? (
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            void creer();
          }}
          sx={{ mt: 2 }}
        >
          <Stack direction="row" spacing={1}>
            <TextField
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              placeholder="Valise de Léa, rentrée, cadeaux…"
              autoFocus
              inputProps={{ maxLength: 80, 'aria-label': 'Nom de la liste' }}
            />
            <Button type="submit" variant="contained" disabled={enCours || nom.trim() === ''}>
              Créer
            </Button>
          </Stack>
        </Box>
      ) : (
        <Button onClick={() => setNouvelle(true)} sx={{ mt: 1 }}>
          Nouvelle liste
        </Button>
      )}
    </Box>
  );
}
